import React from "react";
import './ProductLoading.css';

export const ProductLoading=()=>{
    return (
        <>
            <figure className="container-service-loading">                
                <div className="container-service-img-loading">
                </div>
                <figcaption className="container-service-loading-detail">
                    <div> </div>
                    <div> </div>                  
                    <button></button>   
                </figcaption>
            </figure> 
            <figure className="container-service-loading">                
                <div className="container-service-img-loading" >
                </div>
                <figcaption className="container-service-loading-detail">
                    <div> </div>
                    <div> </div>                             
                    <button></button>   
                </figcaption>
            </figure> 
            <figure className="container-service-loading">                
                <div className="container-service-img-loading" >
                </div>
                <figcaption className="container-service-loading-detail">
                    <div> </div>
                    <div> </div>                             
                    <button></button>   
                </figcaption>
            </figure> 
            <figure className="container-service-loading">                
                <div className="container-service-img-loading" >
                </div>
                <figcaption className="container-service-loading-detail">
                    <div> </div>
                    <div> </div>                             
                    <button></button>   
                </figcaption>
            </figure> 
            <figure className="container-service-loading">                
                <div className="container-service-img-loading" >
                </div>
                <figcaption className="container-service-loading-detail">
                    <div> </div>
                    <div> </div>                             
                    <button></button>   
                </figcaption>
            </figure> 
        </>

    )
}